import {Injectable} from '@angular/core'
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../shared/models/apiurl.models";
import {map} from "rxjs/operators";

interface Notification {
    id: number;
    message: string;
    link?: string;
    timestamp: string;
    is_read: boolean;
    flag: boolean;
}

@Injectable()
export class NotificationBellService {

    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.apuUrl.getJWTToken()
        })
    }

    messages$: Observable<Notification[]>;

    constructor(private http: HttpClient, private apuUrl: ApiUrl) {
        this.notifyNotifications();
    }
    notifyNotifications(){
        this.messages$ = this.getNotifications();
    }
    getNotifications(): Observable<Notification[]> {
        const notification$ = this.http.get<Notification[]>(this.apuUrl.getNotificationsUrl(),  this.options);
        return notification$.pipe(
            map(product => product["results"])
        );
    }

}